import React from 'react';
import './MarketTicker.css';
import { 
  BnbIcon, 
  EthereumIcon, 
  PolygonIcon, 
  AvalancheIcon, 
  HucIcon, 
  ZapIcon 
} from './Icons';

export interface TickerItem {
  symbol: string;
  name: string;
  price: string;
  change: string;
  isPositive: boolean;
  icon?: React.ReactNode;
  isNative?: boolean;
}

interface MarketTickerProps {
  onSelectToken?: (symbol: string) => void;
}

const TICKER_ITEMS: TickerItem[] = [
  { symbol: 'HUC', name: 'HuanChain', price: '$128.50', change: '+5.8%', isPositive: true, icon: <HucIcon size={16} />, isNative: true },
  { symbol: 'BNB', name: 'BNB', price: '$614.85', change: '+2.4%', isPositive: true, icon: <BnbIcon size={16} /> },
  { symbol: 'ETH', name: 'Ethereum', price: '$3,382.40', change: '+3.1%', isPositive: true, icon: <EthereumIcon size={16} /> },
  { symbol: 'BTC', name: 'Bitcoin', price: '$68,420.00', change: '+1.9%', isPositive: true },
  { symbol: 'SOL', name: 'Solana', price: '$179.30', change: '+4.2%', isPositive: true },
  { symbol: 'CAKE', name: 'PancakeSwap', price: '$2.84', change: '+0.8%', isPositive: true },
  { symbol: 'AVAX', name: 'Avalanche', price: '$28.95', change: '+3.5%', isPositive: true, icon: <AvalancheIcon size={16} /> },
  { symbol: 'MATIC', name: 'Polygon', price: '$0.85', change: '+2.0%', isPositive: true, icon: <PolygonIcon size={16} /> },
  { symbol: 'USDC', name: 'USD Coin', price: '$1.000', change: '+0.01%', isPositive: true },
  { symbol: 'USDT', name: 'Tether', price: '$1.000', change: '-0.01%', isPositive: false }
];

export const MarketTicker: React.FC<MarketTickerProps> = ({ onSelectToken }) => {
  return (
    <div className="market-ticker-wrapper" aria-label="Live Market Prices">
      <div className="ticker-label">
        <span className="ticker-pulse-dot" />
        <span className="ticker-label-text">MARKETS</span>
      </div>

      <div className="ticker-viewport">
        <div className="ticker-track">
          {/* Duplicate list to make infinite seamless marquee */}
          {[...TICKER_ITEMS, ...TICKER_ITEMS].map((item, index) => (
            <button
              key={`${item.symbol}-${index}`}
              className={`ticker-chip ${item.isNative ? 'native-chip' : ''}`}
              onClick={() => onSelectToken && onSelectToken(item.symbol)}
              title={`Trade ${item.symbol}`}
              type="button"
            >
              {item.icon && <span className="ticker-chip-icon">{item.icon}</span>}
              <span className="ticker-chip-symbol">{item.symbol}</span>
              <span className="ticker-chip-price">{item.price}</span>
              <span className={`ticker-chip-change ${item.isPositive ? 'positive' : 'negative'}`}>
                {item.isPositive ? '▲' : '▼'} {item.change}
              </span>
            </button>
          ))}
        </div>
      </div>

      <div className="ticker-quick-stats">
        <div className="quick-stat-item" title="24h DEX Protocol Volume">
          <span className="stat-label">24h Vol:</span>
          <span className="stat-value">$1.42B</span>
        </div>
        <div className="quick-stat-divider" />
        <div className="quick-stat-item gas-item" title="Fast Gas Price">
          <ZapIcon size={12} color="#f3ba2f" />
          <span className="stat-value">3 Gwei</span>
        </div>
      </div>
    </div>
  );
};

export default MarketTicker;
